import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on the login page
  const isLoginPage = location.pathname === '/login';

  // Only show sidebar if authenticated AND not on login page
  const showSidebar = isAuthenticated && !isLoginPage;

  // Don't show header and footer on login page
  const showHeaderFooter = !isLoginPage;

  // Handle window resize to detect mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
      if (window.innerWidth < 992) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    // Set initial state
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div style={styles.container}>
      {showHeaderFooter && (
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          showSidebar={showSidebar}
          isMobile={isMobile}
        />
      )}

      <div style={styles.content}>
        {/* Backdrop for mobile sidebar */}
        {showSidebar && isMobile && isSidebarOpen && (
          <div
            style={styles.backdrop}
            onClick={toggleSidebar}
            aria-hidden="true"
          />
        )}

        {showSidebar && (
          <Sidebar
            isOpen={isSidebarOpen}
            isMobile={isMobile}
            toggleSidebar={toggleSidebar}
          />
        )}

        <main style={{
          ...styles.main,
          marginLeft: showSidebar && isSidebarOpen && !isMobile ? 'var(--sidebar-width)' : '0',
          marginTop: showHeaderFooter ? 'var(--header-height)' : '0',
          marginBottom: showHeaderFooter ? 'var(--footer-height)' : '0',
          padding: isMobile ? '1rem' : '2rem',
          width: '100%',
          transition: 'all 0.3s ease',
        }}>
          {children}
        </main>
      </div>

      {showHeaderFooter && <Footer />}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    overflow: 'hidden', // Prevent horizontal scrolling
  },
  content: {
    display: 'flex',
    flex: 1,
    position: 'relative',
    width: '100%',
  },
  main: {
    flex: 1,
    padding: '2rem',
    transition: 'margin-left 0.3s, margin-top 0.3s, margin-bottom 0.3s',
    overflowX: 'hidden', // Prevent horizontal scrolling
  },
  backdrop: {
    position: 'fixed',
    top: 'var(--header-height)',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 90,
    transition: 'opacity 0.3s ease',
  },
};

export default Layout;
